import {appLink, parseOfferSlugToObject} from "@rw/cars_routes";

import {carsCommonUrl} from "../../../app/utils/read_environment_variables";
import {engineTypes, getLabelByValue} from "../../../dashboard/add_car/options/select_options";
import {ICarDetailResponse} from "../actions/fetch_cars_details_at_route";

type CarDetail = ICarDetailResponse["data"];

const formatMileage = (value: string | number | undefined): string | null => {
    if (value === undefined || value === null || value === "") {
        return null;
    }
    const digits = String(value).replace(/\D/g, "");
    if (!digits) {
        return null;
    }
    return `${Number(digits).toLocaleString("pl-PL")} km`;
};

const formatPrice = (value: string | number | undefined): string | null => {
    if (value === undefined || value === null || value === "") {
        return null;
    }
    const digits = String(value).replace(/\D/g, "");
    if (!digits) {
        return null;
    }
    return `${Number(digits).toLocaleString("pl-PL")} zł`;
};

const firstGalleryImage = (car: CarDetail): string | undefined => {
    const gallery = car.acf?.gallery;
    if (!Array.isArray(gallery) || gallery.length === 0) {
        return undefined;
    }
    const first = gallery[0];
    if (typeof first === "string") {
        return first;
    }
    if (first && typeof first === "object") {
        return first.url || first.sizes?.large || first.sizes?.medium || undefined;
    }
    return undefined;
};

export const buildOfferCanonicalUrl = (slug: string): string => {
    try {
        const params = parseOfferSlugToObject(slug);
        return `${carsCommonUrl}${appLink.fullOffer.detail.base(params)}`;
    } catch {
        return `${carsCommonUrl}/oferta/${slug}/`;
    }
};

export const buildOfferMetaTitle = (car: CarDetail): string => {
    const title = (car.title || "").trim();
    if (title) {
        return title.length > 65 ? `${title.slice(0, 62).trim()}…` : title;
    }
    const {make, model, year, city} = car.acf || {};
    return [make, model, year, city].filter(Boolean).join(" ");
};

export const buildOfferMetaDescription = (car: CarDetail): string => {
    const acf = car.acf || ({} as CarDetail["acf"]);
    const fuel = getLabelByValue(acf.engine, engineTypes) || acf.engine;
    const parts: string[] = [];

    const head = [acf.make, acf.model, acf.year].filter(Boolean).join(" ");
    if (head) {
        parts.push(`Na sprzedaż ${head}`);
    }

    const specs: string[] = [];
    if (fuel) {
        specs.push(String(fuel));
    }
    if (acf.horse_power) {
        specs.push(`${acf.horse_power} KM`);
    }
    const mileage = formatMileage(acf.millage);
    if (mileage) {
        specs.push(mileage);
    }
    if (acf.body_type) {
        specs.push(String(acf.body_type));
    }
    if (specs.length) {
        parts.push(specs.join(", "));
    }

    if (acf.city) {
        parts.push(`Lokalizacja: ${acf.city}`);
    }

    const price = formatPrice(acf.price);
    if (price) {
        parts.push(`Cena ${price}`);
    }

    parts.push("Sprawdź ofertę na Zakupauto");

    let description = parts.join(". ").replace(/\.\./g, ".");
    if (!description.endsWith(".")) {
        description += ".";
    }
    if (description.length > 160) {
        description = `${description.slice(0, 157).trim()}…`;
    }
    return description;
};

export const getOfferSeoImage = firstGalleryImage;
